import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LcsResponsiveTableModule, LcsTableModule } from '@lcs/shared/table';
import { SharedReportOutputModule } from '@ndt/report-output/shared/shared-report-output.module';
import { SharedReportsModule } from '@ndt/reports/shared/shared-reports.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { CallParkingLotRegisterModule } from '../call-parking-register/call-logs-register.module';
import { TileParametersModule } from './containers/tile-parameters/tile-parameters.module';
import { TileEffects } from './state/tile.effects';
import { reducer, tilesFeatureKey } from './state/tile.reducer';

@NgModule({
   imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule,
      ReactiveFormsModule,
      DialogModule,
      SharedReportsModule,
      SharedReportOutputModule,
      LcsTableModule,
      RegisterModule,
      TileParametersModule,
      LcsResponsiveTableModule,
      CallParkingLotRegisterModule,
      StoreModule.forFeature(tilesFeatureKey, reducer),
      EffectsModule.forFeature([TileEffects]),
   ],
   exports: [TileParametersModule],
})
export class TilesModule {}
